import {GameCardAssetsRequestParams} from "../components/game-card/assets/game-card-assets.request-params";
import {IMAGE_DEFAULT_FORMATS} from "../app/consts";

export class FieldAssetsRequestParams extends GameCardAssetsRequestParams {
  constructor(width: Number, height: Number, color, sportType) {
    super(width, height, color);

    this.resourceName = this.resourceName + `/icons-lineup-${sportType}`;
    this.ratio = 3;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}
